import React from 'react';
import { st, classes } from './FullScreenModalLayoutHeader.st.css';
import { FullScreenModalLayoutHeaderProps } from '../../FullScreenModalLayout.types';
import { DATA_HOOKS } from '../../FullScreenModalLayout.constants';

const FullScreenModalLayoutHeader = ({
  children,
  startNode,
  endNode,
  dataHook,
  className,
}: FullScreenModalLayoutHeaderProps) => {
  return (
    <div
      data-hook={dataHook || DATA_HOOKS.fullScreenModalLayoutHeader}
      className={st(classes.root, {}, className)}
    >
      {startNode && <div className={classes.startNode}>{startNode}</div>}
      <div className={classes.title}>{children}</div>
      {endNode && <div className={classes.endNode}>{endNode}</div>}
    </div>
  );
};

FullScreenModalLayoutHeader.displayName = 'FullScreenModalLayout.Header';

export { FullScreenModalLayoutHeader };
